















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';

import cCard from '@/components/default/Card.vue';
import cPopup from '@/components/default/Popup.vue';

import tasksRepository from '@/modules/shared/tasks/tasksRepository';

import { DxNavBar } from 'devextreme-vue';

import { TaskStatusOptions, TaskTypeOptions } from '../enums';
import TaskPopup from '../components/TaskPopup.vue';
import TaskNotePopup from '../components/TaskNotePopup.vue';

import EventLogsTable from '@/modules/shared/eventlogs/components/EventLogsTable.vue';
import { EventLogsObjectType } from '@/modules/shared/eventlogs/enums';

import TaskInstructionsRepository from '@/modules/tasks/shared/TaskInstructionsRepository';
import PdfViewer from '@/plugins/pdfjs/PdfViewer.vue';
import employeesRepository from '@/modules/employees/employeesRepository';
import TasksTable from '@/modules/shared/tasks/components/tasksTable.vue';
import { CustomTask, TaskNote, TasksClient, TaskStatus, TaskTemplateDto, TaskTemplatesClient, UpdateTaskStatusCommand, CustomTaskDto } from '@/data/web-api-client';
import ProjectIsOnHoldPopup from '@/components/projects/ProjectIsOnHoldPopup.vue';

@Component({
  components: {
    cCard,
    cPopup,
    DxNavBar,
    TaskPopup,
    TaskNotePopup,
    EventLogsTable,
    PdfViewer,
    TasksTable,
    ProjectIsOnHoldPopup,
  },
})
export default class TaskDetailPage extends Vue {
  catalogList!: any;
  loadingDocument: boolean = false;
  reseting: boolean = false;
  documentAsUrl: any = null;
  initialised: boolean = false;
  loading: boolean = false;
  task: CustomTaskDto | undefined;
  navIndex: number = 0;
  template: TaskTemplateDto | null = null;
  parent: CustomTask | undefined;
  pdfSize: number = 500;
  notes: TaskNote[] = [];

  status: string = '';

  tasksClient: TasksClient = new TasksClient(undefined, this.$axios);
  taskTemplatesClient: TaskTemplatesClient = new TaskTemplatesClient(undefined, this.$axios);

  mounted() {
    this.loadData();
    this.pdfSize = window.innerHeight - 275;
  }

  async loadData() {
    try {
      this.loading = true;
      this.task = await this.tasksClient.getItem(this.routeId);
      if (this.task.notes) {
        this.notes = this.task.notes;
      }
      if (this.task.status != undefined) {
        const status = TaskStatusOptions.find((o) => o.value === (this.task as CustomTask).status)!;
        this.status = status.text;
      }

      this.loadTemplate();
      this.loadParent();

      setTimeout(() => {
        if (this.$route.query.checkProjectOnHold === 'true' && this.task?.projectIsOnHold) {
          this.projectIsOnHoldPopup.show();
        }
      }, 200);
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.initialised = true;
      this.loading = false;
    }
  }

  async loadParent() {
    try {
      if (!this.task || !this.task.parentId || this.task.parentId === '') {
        return;
      }
      this.parent = await this.tasksClient.getItem(this.task.parentId);
    } catch (err) {
      notificationService.showAxiosError(err);
    }
  }

  async loadTemplate() {
    try {
      if (!this.task) {
        return;
      }

      if (!this.task.templateId || this.task.templateId === '') {
        return;
      }

      this.template = await this.taskTemplatesClient.getItem(this.task.templateId)!;
      if (this.template.instructionId && this.template.instructionId !== '') {
        this.loadDocument();
      }
    } catch {
      // do nothing
    }
  }

  async loadDocument() {
    try {
      this.loadingDocument = true;

      if (!this.template || !this.template.instructionId) {
        return;
      }

      const document = (await TaskInstructionsRepository.download(this.template.instructionId)).data;
      this.documentAsUrl = window.URL.createObjectURL(document);
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loadingDocument = false;
    }
  }

  getUsername(id: string) {
    if (!id || id === '') {
      return '';
    }

    const user = this.$store.getters['employees/itemByUserId'](id);
    if (user) {
      return user.displayName;
    }

    return '';
  }

  edit() {
    (this.$refs.TaskPopup as TaskPopup).show();
  }

  insertNote(note: any) {
    if (!this.task) {
      return;
    }

    if (!this.task.notes) {
      this.task.notes = [];
    }

    this.notes = [...this.task.notes, new TaskNote(note)];

    this.task.notes = this.notes;
  }

  addNote() {
    (this.$refs.TaskNotePopup as TaskNotePopup).show();
  }

  async deleteTask() {
    if (!this.task || !this.task.id) {
      return;
    }

    if (confirm('Bent u zeker dat u deze taak wenst te wissen?')) {
      try {
        await tasksRepository.delete(this.task.id);
        this.$router.push({ path: `/tasks` });
      } catch (err) {
        notificationService.showAxiosError(err);
      }
    }
  }

  async completedTask() {
    await this.tasksClient
      .updateStatus(
        this.routeId,
        new UpdateTaskStatusCommand({
          id: this.routeId,
          status: TaskStatus.Closed,
        })
      )
      .finally(async () => {
        this.task = await this.tasksClient.getItem(this.routeId);
        const status = TaskStatusOptions.find((o) => o.value === (this.task as CustomTask).status);

        if (status) {
          this.status = status.text;
        }

        const newTaskPopup = this.$refs.NewTaskPopup as TaskPopup;

        newTaskPopup.show();
        newTaskPopup.dto.templateId = this.template?.nextTaskTemplateId!;
      });
  }

  get sortedNotes() {
    return this.notes.slice().reverse();
  }

  get navbarItems() {
    const self = this;
    return [
      { icon: 'fas fa-info-circle', text: 'Info' },
      {
        icon: 'fas fa-file-pdf',
        text: 'Handleiding',
        visible: self.template && self.template.instructionId && self.template.instructionId !== '',
      },
      { icon: 'fas fa-history', text: 'Geschiedenis' },
    ];
  }

  get routeId() {
    return this.$route.params.id;
  }

  get team() {
    if (this.task && this.task.team) {
      const team = employeesRepository.getTeam(this.task.team);

      if (team) {
        return team.text;
      }

      return '';
    }
    return '';
  }

  get historyConfig(): IEventLogQuery {
    return {
      objectId: this.routeId,
      type: EventLogsObjectType.Task,
    };
  }

  // get status() {
  //   if (this.task) {
  //     const status = TaskStatusOptions.find((o) => o.value === (this.task as CustomTask).status);
  //     if (status) {
  //       return status.text;
  //     }
  //   }
  //   return '';
  // }

  get contactLink() {
    if (!this.task || !this.task.customer || !this.task.customer.type) {
      return '';
    }

    switch (this.task.customer.type.toLowerCase()) {
      case 'contact':
        return '/contacts/' + this.task.customer.id;
      case 'company':
        return '/companies/' + this.task.customer.id;
      case 'subcontractor':
        return '/subcontractors/' + this.task.customer.id;
    }

    return '';
  }

  get type() {
    if (this.task) {
      const status = TaskTypeOptions.find((o) => o.value === (this.task as CustomTask).type);
      if (status) {
        return status.text;
      }
    }
    return '';
  }

  get content() {
    if (this.task && this.task.description) {
      let c = '' + this.task.description;
      while (c.indexOf('\n') !== -1) {
        c = c.replace('\n', '<br />');
      }

      return c;
    }

    return '';
  }

  get projectIsOnHoldPopup() {
    return this.$refs.projectIsOnHoldPopup as ProjectIsOnHoldPopup;
  }

  @Watch('routeId')
  async onRouteChanged() {
    this.reseting = true;
    this.documentAsUrl = null;
    this.initialised = false;
    this.template = null;
    setTimeout(() => {
      this.reseting = false;
    }, 200);
    await this.loadData();
  }
}
